import { render, staticRenderFns } from "./SegmentedTrendsConversionTable.vue?vue&type=template&id=e2149638&scoped=true"
import script from "./SegmentedTrendsConversionTable.vue?vue&type=script&lang=ts"
export * from "./SegmentedTrendsConversionTable.vue?vue&type=script&lang=ts"
import style0 from "./SegmentedTrendsConversionTable.vue?vue&type=style&index=0&id=e2149638&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2149638",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/segmented-trends/segmented-trends-conversion-table.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsegmented-trends%2FSegmentedTrendsConversionTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports